import * as types from "../actions/actionTypes";
import * as config from "../data/config";
import flightDetailsApi from "../api/flightDetailsApi";
import LocalStorageHelper from "../common/localStorageHelper";
import { IsHeadStart, IsTerminatorFlight } from "../common/helper";

export function setFlightDetails(newData, flightFilters, isInitialization = false) {
    return (dispatch) => {
        dispatch({
            type: types.GET_FLIGHTDETAILS_REQUEST,
        });
        let allFlights = [];
        let allModels = [];
        let allGatess = [];
        let allGatess11 = [];
        let firstList = [];

        let allFlightsData = newData.flightDetails;

        var moment = require("moment");

        let combinedFilters = [];
        const flightFL = flightFilters.flightNumberFilters ? flightFilters.flightNumberFilters : [];
        const aircaraftFL = flightFilters.aircraftFilters ? flightFilters.aircraftFilters : [];
        const gateFL = flightFilters.gateFilters ? flightFilters.gateFilters : [];
        combinedFilters = [...flightFL, ...aircaraftFL, ...gateFL];
        flightFilters.flightFilters = combinedFilters;

        const storedStation = LocalStorageHelper.selectedStation.get();

        let newFlightData = newData.flightDetails?.map((flightDetail) => {
            if (flightDetail.DepGate === "" || flightDetail.DepGate === null) {
                flightDetail.DepGate = "X";
            }

            if (flightDetail.TerminatorFlight && (flightDetail.ArrGate === "" || flightDetail.ArrGate === null)) {
                flightDetail.ArrGate = "X";
            }

            if (flightDetail.FltNumInbound && flightDetail.IATAMarketingcodeInbound)
                allFlights.push(flightDetail.IATAMarketingcodeInbound + " " + flightDetail.FltNumInbound);
            if (flightDetail.FltNumOutbound && flightDetail.IATAMarketingcodeOutbound)
                allFlights.push(flightDetail.IATAMarketingcodeOutbound + " " + flightDetail.FltNumOutbound);

            //Model Filter
            if (flightDetail.ModelInbound) allModels.push(flightDetail.ModelInbound);
            if (flightDetail.ModelOutbound) allModels.push(flightDetail.ModelOutbound);

            if (flightDetail.GatesDetails) allGatess11.push(flightDetail.GatesDetails);

            return flightDetail;
        });

        allFlights = [...new Set(allFlights)];

        allModels = [...new Set(allModels)];
        if (!flightFilters.aircraftFilters) {
            flightFilters.aircraftFilters = allModels;
        }

        firstList = allGatess11[0];

        allGatess11 = firstList;

        if (!flightFilters.gateFilters) {
            flightFilters.gateFilters = allGatess11;
        }

        const stationFlight = allFlightsData.find((flight) => flight.DepAirport === storedStation);

        let refreshedTime = "";
        if (stationFlight && !isInitialization) {
            const stdUtcOutbound = moment(stationFlight.STD_UTC_Outbound);
            const stdOutbound = moment(stationFlight.STD_Outbound);
            const timeDifferenceInMinutes = stdUtcOutbound.diff(stdOutbound, "minutes");

            const currentUtcTime = moment.utc();
            refreshedTime = currentUtcTime.subtract(timeDifferenceInMinutes, "minutes").format("YYYY-MM-DD HH:mm:ss");
        }

        let dispatchObj = {
            type: types.SET_FLIGHTDETAILS,
            flightDetail: null,
            filteredFlightDetails: null,
            flightFilters: flightFilters,
            allFlights: allFlights,
            allFlightsData: allFlightsData,
            allModels: allModels,
            allGatess11: allGatess11,
            refreshedTime: refreshedTime,
        };
        if (!config.environment.settings.ignoreFlightFilter) {
            //Filter by hours
            let maxHours = flightFilters.hourFilter ?? 1;
            let now = moment(new Date()); //current date / time
            let filterByHours = newFlightData.filter((flightDetail) => {

                if (flightDetail.OffTimeOutbound != null && flightDetail.TerminatorFlight == 0) {
                    return false;
                }
                else if (IsHeadStart(flightDetail)) {
                    // ETD_Outbound
                    let end = moment(flightDetail.ETD_Outbound);
                    let duration = moment.duration(end.diff(now));
                    let hoursToDep = duration.asHours();
                    if (0 <= hoursToDep && hoursToDep <= maxHours) {
                        return true;
                    }
                }
                else if (IsTerminatorFlight(flightDetail)) {
                    return true;
                }
                else {
                    // ETD_Outbound
                    let end = moment(flightDetail.ETD_Outbound);
                    let duration = moment.duration(end.diff(now));
                    let hoursToDep = duration.asHours();
                    // ETA_Inbound
                    end = moment(flightDetail.ETA_Inbound);
                    duration = moment.duration(now.diff(end));
                    let hoursToArr = duration.asHours();

                    if (0 <= hoursToArr && hoursToArr <= maxHours) {
                        return true;
                    }
                    else if (0 <= hoursToDep && hoursToDep <= maxHours) {
                        return true;
                    }
                }
            });

            // Filter by gates
            let filteredByGate = filterByHours;
            if (flightFilters.gateFilters && flightFilters.gateFilters.length > 0) {
                filteredByGate = filterByHours.filter((flightDetail) => {
                    return flightDetail.TerminatorFlight > 0
                        ? flightFilters.gateFilters.includes(flightDetail.ArrGate)
                        : flightFilters.gateFilters.includes(flightDetail.DepGate);
                });
            }

            // filter by fleet type
            let filterByAircraft = filteredByGate;
            if (flightFilters.aircraftFilters && flightFilters.aircraftFilters.length > 0) {
                filterByAircraft = filteredByGate.filter((flightDetail) => {
                    return (
                        flightFilters.aircraftFilters.includes(flightDetail.ModelInbound) ||
                        flightFilters.aircraftFilters.includes(flightDetail.ModelOutbound)
                    );
                });
            }

            let filteredFlightDetails = [...new Set(filterByAircraft)];

            // flight/tail number search
            let flightOrTailNumberSearch = flightFilters.flightOrTailNumberSearch;
            let searchbyNumberResult = newFlightData.filter((flight) => {
                return (
                    flightOrTailNumberSearch &&
                    (flight.FltNumOutbound?.includes(flightOrTailNumberSearch) ||
                        flight.FltNumInbound?.includes(flightOrTailNumberSearch) ||
                        flight.UncorrectedTailNum?.includes(flightOrTailNumberSearch) ||
                        flight.UncorrectedTailNumInbound?.includes(flightOrTailNumberSearch) ||
                        flight.PreviousTailNumInbound?.includes(flightOrTailNumberSearch) ||
                        flight.PreviousTailNumOutbound?.includes(flightOrTailNumberSearch))
                );
            });

            // create intersection array from filteredFlightDetails and searchbyNumberResult
            if (flightOrTailNumberSearch) {
                filteredFlightDetails = filteredFlightDetails.filter((flight) => {
                    return (
                        flight.LegHashKeyOutbound &&
                        searchbyNumberResult.some((f) => flight.LegHashKeyOutbound === f.LegHashKeyOutbound)
                    );
                });
            }

            dispatchObj.filteredFlightDetails = filteredFlightDetails;
        } else {
            dispatchObj.filteredFlightDetails = newFlightData;
        }

        dispatchObj.flightDetail = newFlightData;
        dispatchObj.flightFilters = flightFilters;

        LocalStorageHelper.appliedFilters.set(flightFilters);

        dispatch(dispatchObj);

        setTimeout(() => {
            dispatch({
                type: types.GET_FLIGHTDETAILS_REQUEST_DONE,
            });
        }, 3000);
    };
}

export function resetFlight() {
    const connectionId = localStorage.getItem("ConnectionId");

    let api = config.environment.api;
    let url = api.baseURL + api.removeConnection + "/" + connectionId;

    let user = LocalStorageHelper.getUser();
    let token = "";
    if (user && user.token) token = user.token;

    fetch(url, {
        method: "DELETE",
        headers: {
            Authorization: token,
        },
    })
        .then((response) => {
            if (!response.ok) {
                console.log("Removing connection was not successful.");
            } else {
                console.log("connection removed successfully.");
            }
        })
        .catch((error) => {
            console.error("Removing connection was not successful.", error);
        });

    return (dispatch) => {
        dispatch({
            type: types.RESET_FLIGHT,
        });
    };
}

export function dataReceived() {
    var moment = require("moment");

    return (dispatch, getState) => {
        dispatch({
            type: types.DATA_RECEIVED,
            lastUpdate: moment(),
        });
    };
}

export function filterStation(station = "") {
    return (dispatch, getState) => {
        dispatch({
            type: types.FILTER_STATION,
            station: station,
        });
    };
}

export function getFlightData(flightFilters, stationCode) {
    var moment = require("moment");
    return (dispatch) => {
        dispatch({
            type: types.GET_FLIGHTDETAILS_REQUEST,
        });
        return flightDetailsApi
            .fetchFlightDetails(stationCode)
            .then((data) => {
                let serverOffSet = moment(data.serverTime).diff(moment(), "milliseconds");

                //debugger
                dispatch({
                    type: types.GET_FLIGHTDETAILS_SUCCESS,
                    lastUpdate: moment(),
                    flightFilters: flightFilters,
                    serverOffSet: serverOffSet,
                });
                dispatch(setFlightDetails(data, flightFilters));
            })
            .catch((error) => {
                dispatch({
                    type: types.GET_FLIGHTDETAILS_FAIL,
                    payload: error.message,
                });
            });
    };
}
